import React from 'react';
import { motion } from 'framer-motion';
import { BannerSlider, type BannerItem } from './BannerSlider';
const volumes: BannerItem[] = [{
  id: '01',
  label: 'Volume 01',
  title: 'FULL BODY SESSIONS',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1600&q=80',
  description: 'Complete 45-minute full body stretching classes, ready to teach today. Exact sequences, hold times, transitions and verbal cues — for every level.'
}, {
  id: '02',
  label: 'Volume 02',
  title: 'TARGETED ZONE SESSIONS',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1591258370814-01609b341790?auto=format&fit=crop&w=1600&q=80',
  description: 'Laser-focused sessions for specific body parts: lower back, hips, hamstrings, shoulders, neck and chest. Standalone or stackable into longer classes.'
}, {
  id: '03',
  label: 'Volume 03',
  title: 'MORNING & EVENING PROTOCOLS',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=1600&q=80',
  description: 'Energizing morning sessions and deep recovery evening sessions — each scripted, timed and toned for the right moment of the day.'
}, {
  id: '04',
  label: 'Volume 04',
  title: 'SPECIAL POPULATIONS',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?auto=format&fit=crop&w=1600&q=80',
  description: 'Ready-to-teach sessions for seniors, office workers, post-workout athletes and prenatal clients. Safety notes and modifications included for every group.'
}, {
  id: '05',
  label: 'Volume 05',
  title: 'EXPRESS FORMATS',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1600&q=80',
  description: '10, 15 and 20-minute sessions for every situation: corporate slots, pre-class warm-ups, post-training recovery. Fits on one page. Open it. Teach it.'
}, {
  id: '06',
  label: 'Volume 06',
  title: 'THEMED CLASSES',
  meta: '80–100 pages',
  image: 'https://images.unsplash.com/photo-1545205597-3d9d02c29597?auto=format&fit=crop&w=1600&q=80',
  description: '8 themed sessions to keep your students coming back every week — Stress Relief, Deep Release, Sports Recovery, Postural Reset, Flexibility Challenge and more.'
}];
export function SystemSection() {
  return <section className="py-12 sm:py-24 bg-slate-950 text-white relative overflow-hidden" data-id="element-203">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-204" />
      <div className="absolute -top-1/4 left-1/2 -translate-x-1/2 h-[40rem] w-[40rem] rounded-full bg-brand-500/10 blur-[120px]" data-id="element-205" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="mx-auto max-w-3xl text-center mb-10 sm:mb-16" data-id="element-207">
          <h2 className="text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-brand-400" data-id="element-208">
            The Complete System
          </h2>
          <p className="mt-3 font-display sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white text-balance text-[18px]" data-id="element-209">
            Six comprehensive volumes — over{' '}
            <span className="text-brand-400" data-id="element-210">600 pages</span> of pure teaching
            content
          </p>
          <p className="mt-4 sm:mt-6 sm:text-lg sm:leading-8 text-slate-400 text-[14px]" data-id="element-211">
            The foundation of everything. Six volumes of pure stretching gold.
            Stop reacting to whatever your students need in the moment and start
            delivering classes that truly transform how they move and feel.
          </p>
        </div>

        {/* Main product mockup at 80% */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="mx-auto mb-10 sm:mb-16 w-4/5 max-w-3xl" data-id="element-212">
          <img src="https://cdn.magicpatterns.com/uploads/4dgsTa4MyNzpLdaXEDcrK2/Gemini_Generated_Image_8lvaxp8lvaxp8lva-Photoroom.png" alt="Stretching Ready Complete System Bundle" className="w-full" data-id="element-213" />
        </motion.div>

        <BannerSlider items={volumes} accent="volume" data-id="element-214" />
      </div>
    </section>;
}